import React from 'react'
import BloodGlucoseRangeItem from '../RangeItems/BloodGlucoseRangeItem'
import { Box, Divider } from '@mui/material'

export default function BloodPressureCard (props) {
  const sectionData = props.sectionData

  const renderDivider = (shouldShow) => {
    return (<>{shouldShow && !props.shouldRenderCondensed && <Divider className='care-plan-item__divider' />}</>)
  }

  return (
    <div className='care-plan__section' data-testid='care-plan__section__blood-glucose'>
      <div className='care-plan__section-header'>Blood Glucose</div>
      {sectionData.rangeSubTypes.map((item, i, allElements) => {
        return (
          <Box key={`bloodglucoserangeitem__${item}`}>
            <BloodGlucoseRangeItem {...props} subtype={item} />
            {renderDivider(i < allElements.length - 1)}
          </Box>
        )
      })}
    </div>
  )
}
